import React, { useCallback, useEffect, useState } from "react";
import BaseCard from "../components/BaseCard";
import styles from "./index.module.less";
import { message as toast } from "antd";
import { RightOutlined } from "@/utils/antdIcon";
import { queryTodoList } from "@/api/workCards";
import moment from "moment";
import Bus from "@/utils/bus";

// 紧急程度中文映射关系
const priorityLevel: any = {
  0: "普通",
  1: "紧急",
  2: "加急",
  3: "特急",
  4: "特提"
};

// 紧急程度背景色映射关系
const priorityOpts: any = {
  0: "common",
  1: "urgent",
  2: "urgents",
  3: "extra-urgent",
  4: "special-mention"
};

function TodoCard(props: any) {
  const { cardInfo, openNewPage, isPrivateNet } = props;
  const [todoData, setTodoData] = useState<any>({});
  const [showAll, setShowAll] = useState<any>(false);

  // 点击查看详情
  const viewDetail = (data: any) => {
    let openUrl;
    if (isPrivateNet) {
      if (data.redirectUrlPcEgov) {
        openUrl = data.redirectUrlPcEgov;
      } else {
        toast.error("请到对应应用中处理该条待办");
        return;
      }
    } else {
      if (data.redirectUrlPc) {
        openUrl = data.redirectUrlPc;
      } else {
        toast.error("请到对应应用中处理该条待办");
        return;
      }
    }
    let params = {
      openUrl: openUrl,
      appKey: data.appKey,
      openApiType: data.openApiType
    };
    openNewPage(params);
  };

  // 点击查看列表
  const viewList = () => {
    let params = {
      openUrl: isPrivateNet ? todoData.descUrlEgov : todoData.descUrl,
      appKey: cardInfo.applicationKey,
      openApiType: 1
    };
    openNewPage(params);
  };

  // 查询待办列表
  const getTodoList = useCallback(async () => {
    try {
      let res: any = await queryTodoList({
        itemStatus: 0,
        pageNo: 1,
        pageSize: 5
      });
      // 错误处理。。。
      if (res?.errorCode) {
        toast.error(res.errorMsg);
        return;
      }
      let showFlag = false;
      if (isPrivateNet) {
        showFlag = res.descUrlEgov ? true : false;
      } else {
        showFlag = res.descUrl ? true : false;
      }
      setShowAll(showFlag);
      setTodoData(res);
    } catch (e) {
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 查询待办列表
    getTodoList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Bus.on(`chat_message_multiSync_event:${cardInfo?.applicationKey}`, getTodoList);
    return () => {
      Bus.off(`chat_message_multiSync_event:${cardInfo?.applicationKey}`, getTodoList);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseCard>
      <div className={styles["todo-list-wrap"]}>
        <div className={styles["todo-list-header"]}>
          <div className={styles["todo-list-header-title"]}>
            <img className={styles["card-logo"]} src={cardInfo?.icon} alt="" />
            <span className={styles["title"]}>{cardInfo?.name || "待办事项"}</span>
            <span className={styles["num"]}>{todoData?.total || 0}</span>
          </div>
          {showAll ? (
            <div className={styles["todo-list-header-more"]} onClick={viewList}>
              <span className={styles["title-more"]}>全部</span>
              <RightOutlined className={styles["more-icon"]} />
            </div>
          ) : null}
        </div>
        <ul className={styles["todo-lists-wrap"]}>
          {todoData.backLogList?.length > 0 ? (
            todoData.backLogList.map((item: any) => {
              return (
                <li
                  className={styles["todo-lists-item"]}
                  key={item.itemId}
                  onClick={() => viewDetail(item)}
                >
                  <div className={styles["todo-item-name"]}>
                    {item?.priority || item?.priority === 0 ? (
                      <span
                        className={`${styles[priorityOpts[item.priority]]} ${
                          styles["todo-item-urgency"]
                        }`}
                      >
                        {priorityLevel[item.priority]}
                      </span>
                    ) : null}
                    <p className={styles["name"]}>{item?.itemName}</p>
                  </div>
                  <span className={styles["todo-item-time"]}>
                    {moment(item?.submitTime).format("MM月DD日 HH:mm")}
                  </span>
                </li>
              );
            })
          ) : (
            <div className={styles["no-data"]}>
              <div>暂无新的待办</div>
            </div>
          )}
        </ul>
      </div>
    </BaseCard>
  );
}

export default TodoCard;
